import { action } from 'satcheljs';
export let messageBeingSent = action('messageBeingSent');
